var cifBf = ["301 201", "<g fill='none'><path fill='#009E49' d='M.5.5h300v200H.5z'/><path fill='#EF2B2D' d='M.5.5h300v100H.5z'/><path fill='#FCD116' d='M118.798 90.199l19.593 14.235-7.484 23.033 19.593-14.235 19.593 14.235-7.484-23.033 19.593-14.235h-24.218L150.5 67.166l-7.374 23.033z'/></g>"];

export { cifBf };

